// ════════════════════════════════════════════════════════════════════════
// ProtectedRoute.tsx — Bloquea rutas que requieren sesión iniciada
// ════════════════════════════════════════════════════════════════════════
// Si no hay usuario autenticado, redirige a la landing ("/").
// Envuelve cualquier <Route element={...}> que dependa de useAuth().
// ════════════════════════════════════════════════════════════════════════

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/shared/context/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
